import { render, staticRenderFns } from "./IncraQuilombolas.vue?vue&type=template&id=8fd3f5e4&lang=pug"
import script from "./IncraQuilombolas.vue?vue&type=script&lang=js"
export * from "./IncraQuilombolas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports